<template>
  <div class="bbp-step" :class="{'bbp-step_min-mode': minViewMode}">
    <div class="bbp-step-header" :class="{'bbp-step-header_view-mode': noEdit}">
      <i class="bbp-icon-menu bbp-step-header-menu"
         v-if="!noEdit"
         @click="openPopupStep"
         v-click-outside="closePopupStep">
        <transition name="bbp-bounce">
          <div class="bbp-step-header-menu-popup"
               @mouseleave="closePopupStep"
               :style="popupPosition" v-if="openControlStep">
            <div class="bbp-step-header-menu-popup__item" @click.stop="openEditStep">Edit</div>
            <div class="bbp-step-header-menu-popup__item" @click.stop="openDeleteStep">Delete</div>
          </div>
        </transition>
      </i>
      <div class="bbp-step-header__date">{{ dateStart }}</div>
      <div class="bbp-step-header-time" v-if="totalTime">
        <i class="bbp-icon-clock bbp-step-header-time__icon"/>
        <span>{{ totalTime }}</span>
      </div>
      <div class="bbp-step-header-user" v-if="step.user">
        <div>{{ username }}</div>
        <img class="bbp-step-header-user__photo" :src="userPhoto" v-if="userPhoto">
        <i class="bbp-icon-user bbp-step-header-user__photo" v-else/>
      </div>
    </div>
      <div :key="step.id + '_action-taken'" class="bbp-step-content-item">
        <div class="bbp-step-content-item__title">Comment</div>
        <pre class="bbp-step-content-item__text">{{ step.comment }}</pre>
      </div>
    <div class="bbp-step-files" v-if="files.length !== 0">
      <div class="bbp-step-files-list">
        <div class="bbp-step-files-list-item" v-for="file in files" :key="file.id" @click="openFile(file)">
          <i class="bbp-step-files-list-item__icon bbp-icon-document"/>
          <span class="bbp-step-files-list-item__filename">{{ file.label }}</span>
          <span class="bbp-step-files-list-item__size" v-if="file.size">{{ getFileSize(file.size) }}</span>
        </div>
      </div>
    </div>
    <transition name="bbp-fade">
      <BBPDoubleDelete v-if="openDoubleDelete"
                       :id="step._id"
                       :title="'Delete the entry from ' + dateStart"
                       @close="closeDeleteStep"
                       @delete="deleteStep"/>
    </transition>
  </div>
</template>

<script>
import moment from 'moment'
import {set, get, findIndex} from 'lodash'
import FilesApi from '@/api/Files/api'
import StepsApi from '@/api/Steps/api'
import {HOURLY, SIDE_HOURLY} from '@/constants/projectTypes'
import getFileSize from '@/mixin/getFileSize'
import {saveAs} from 'file-saver'
import BBPDoubleDelete from '@/components/Main/BBPDoubleDelete/BBPDoubleDelete'
import b64toBlob from 'b64-to-blob'
import convertSecondsToTime from '@/mixin/convertSecondsToTime'

export default {
  name: 'StepCard',
  props: ['step', 'project', 'noEdit', 'minViewMode'],
  mixins: [getFileSize, convertSecondsToTime],
  components: {BBPDoubleDelete},
  data () {
    return {
      popupPosition: {},
      openControlStep: false,
      openDoubleDelete: false,
      dateSet: {}
    }
  },
  computed: {
    totalTime () {
      const { totalTime } = this.step
      const sec = Math.floor(totalTime / 1000)
      return this.convertSecondsToTime(sec, true)
    },
    files () {
      return get(this.step, 'uploadFile', [])
    },
    dateStart () {
      const date = get(this.step, 'dateStart', '')
      return this.formatDate(date)
    },
    dateNextUpdate () {
      const date = get(this.step, 'dateNextUpdate', '')
      return this.formatDate(date)
    },
    isHourlyProject () {
      const type = get(this.project, 'projectType', '')
      return type === HOURLY.id || type === SIDE_HOURLY.id
    },
    user () {
      const { user = [] } = this.step
      const [item = {}] = user
      return item
    },
    username () {
      return get(this.user, 'username', '')
    },
    userPhoto () {
      return get(this.user, 'image.path', '')
    },
    projectId () {
      return get(this.project, '_id', '')
    },
    usersListProjects: {
      get () {
        return this.$store.getters.usersListProjects
      },
      set (data) {
        this.$store.dispatch('setUsersListProjects', data)
      }
    },
    stepsList: {
      get () {
        return this.$store.getters.stepsList
      },
      set (data) {
        this.$store.dispatch('setStepsList', data)
      }
    }
  },
  methods: {
    closePopupStep () {
      this.openControlStep = false;
    },
    openEditStep () {
      this.closePopupStep();
      this.$emit('openEdit', this.step);
    },
    openDeleteStep () {
      this.openDoubleDelete = true;
    },
    closeDeleteStep () {
      this.openDoubleDelete = false;
    },
    deleteStep (id) {
      const stepsList = get(this.stepsList, this.projectId, []);
      const index = findIndex(stepsList, {_id: id});
      const deletedStep = index !== -1 ? stepsList.splice(index, 1) : [];

      set(this.stepsList, this.projectId, stepsList);
      StepsApi.deleteStep(id)
        .then(resp => {
          const {data: { subTimer: { totalTime, _id }}} = resp;
          this.$store.dispatch('setRemovedProjectSteps', {totalTime, _id});
          return resp;
        })
        .catch(err => {
          if (deletedStep) stepsList.splice(index, 0, ...deletedStep);
          set(this.stepsList, this.projectId, stepsList);
          console.error(err);
        })
      this.closeDeleteStep();
    },
    openPopupStep (e) {
      const position = e.target.getBoundingClientRect()
      if (position) {
        this.popupPosition = {
          position: 'fixed',
          top: position.top + position.height + 5 + 'px',
          left: position.left - 34 + 'px'
        }
      }
      this.openControlStep = !this.openControlStep
    },
    openFile (file) {
      const fileId = get(file, 'id', '')
      if (!fileId) return
      this.dateSet[fileId] ? saveAs(this.dateSet[fileId].blob, this.dateSet[fileId].label) : this.getFile(fileId)
    },
    getFile (fileId) {
      this.$emit('loader', true)
      FilesApi.getFile(fileId)
        .then(resp => {
          const blob = b64toBlob(resp.data.base64, resp.data.type)
          this.dateSet[resp.data.id] = {id: resp.data.id, blob, label: resp.data.label}
          saveAs(blob, resp.data.label)
          this.$emit('loader', false)
        })
        .catch(err => {
          console.error(err)
          this.$emit('loader', false)
        })
    },
    formatDate (date) {
      const momentDate = moment(date)
      const isValid = momentDate.isValid()
      return isValid ? momentDate.format('DD MMM, YYYY') : ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bbp-step {
  @include global-font;
  display: flex;
  flex-direction: column;
  background: $color-white;
  box-shadow: 0 0 20px rgba($color-black, 0.05);
  border-radius: 5px;
  min-width: 440px;
  width: 440px;
  height: max-content;
  min-height: 269px;
  transition: 0.3s;

  &_min-mode {
    min-height: 200px;
  }

  &-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 13px 16px 13px 2px;
    border-bottom: 2px solid $color-alabaster;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    min-height: 56px;
    color: $color-accent;

    &_view-mode {
      padding: 13px 16px 13px 16px;
    }

    &-menu {
      @include global-font;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 30px;
      margin: 0 6px;
      font-size: 14px;
      transition: 0.3s;
      border-radius: 8px;
      background-color: transparent;
      cursor: pointer;
      user-select: none;

      &:hover {
        color: $color-accent-hover;
        background-color: rgba($color-link-water, 0.4);
      }

      &-popup {
        position: absolute;
        bottom: -73px;
        left: auto;
        min-height: 68px;
        max-height: 68px;
        min-width: 92px;
        max-width: 92px;
        background: $color-white;
        box-shadow: 0 0 15px rgba($color-black, 0.12);
        border-radius: 4px;
        z-index: 5;

        &__item {
          font-weight: normal;
          font-size: 12px;
          line-height: 14px;
          text-align: center;
          color: $color-black;
          padding: 10px;
          transition: 0.3s;

          &:hover {
            color: $color-accent;
          }

          &:last-child {
            box-sizing: border-box;
            border-top: 1px solid $color-wild-sand;
          }
        }

        &:before {
          content: '';
          position: absolute;
          left: 40px;
          top: -6px;
          display: block;
          width: 0;
          height: 0;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-bottom: 6px solid $color-white;
        }
      }
    }

    &__date {
      padding: 8px 14px;
      background: $color-link-water;
      border-radius: 33px;
      cursor: default;
    }

    &-time {
      margin-left: 12px;
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;

      &__icon {
        font-size: 14px;
        line-height: 1;
        margin-right: 5px;

        &:before {
          margin: 0;
        }
      }
    }

    &-user {
      margin-left: auto;
      display: grid;
      grid-template-columns: auto 28px;
      grid-gap: 9px;
      align-items: center;
      text-transform: capitalize;
      cursor: default;

      &__photo {
        border-radius: 50%;
        color: $color-accent;
        width: 28px;
        height: 28px;
        font-size: 28px;
        object-fit: cover;
      }
    }
  }

  &-content {
    height: 100%;
    margin: 14px 0;
    padding-right: 16px;
    word-break: break-word;

    &-item {
      color: $color-black;
      padding: 12px 0 12px 16px;

      &__title {
        position: relative;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 5px;

        &:before {
          content: '';
          position: absolute;
          left: -16px;
          top: 0;
          height: 20px;
          width: 3px;
          background: $color-accent;
          border-radius: 0 3px 3px 0;
        }
      }

      &__text {
        font-weight: normal;
        font-size: 13px;
        line-height: 16px;
        white-space: pre-line;
      }
    }
  }

  &-files {
    padding: 0 16px 16px;

    &-list {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: start;

      &-item {
        display: grid;
        grid-template-columns: 31px auto;
        grid-gap: 3px 8px;
        font-size: 11px;
        line-height: 13px;
        margin-right: 9px;
        padding: 8px;
        border: 1px solid transparent;
        box-sizing: border-box;
        border-radius: 6px;
        white-space: nowrap;
        transition: 0.4s;
        cursor: pointer;

        &:hover {
          border-color: $color-link-water;
        }

        &:last-child {
          margin-right: 0;
        }

        &__icon {
          grid-row: 1/3;
          width: 31px;
          height: 31px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: $color-accent;
          background-color: $color-link-water;
          font-size: 18px;
          border-radius: 6px;
        }

        &__filename {
          max-width: 242px;
          overflow: hidden;
          text-overflow: ellipsis;
          color: $color-black;
          font-weight: 500;
        }

        &__size {
          color: $color-silver;
          font-weight: normal;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Projects/ProjectCard/StepCard/StepCard.vue